import z from 'zod';
import { phoneSchema } from './others';

// STORE SCHEMAS
export const StoreBrandFiles = z.object({
  store_logo: z
    .instanceof(File, { message: 'Please upload your store logo' })
    .optional(),
  store_banner: z
    .instanceof(File, { message: 'Please upload your store banner' })
    .optional(),
});

export const StorePrimaryInfo = z.object({
  store_id: z.number().optional(),
  ownerId: z.number().optional(),
  logo: z.number().optional(),
  banner_image: z.number().optional(),
  name: z.string({ message: 'store name is required' }),
  description: z.string({ message: 'store description is required' }),
  contact_phone: phoneSchema.optional(),
  contact_email: z.email({ message: 'provide a valid store email' }).optional(),
  //TODO: add later opening_hours:
  address: z.string({ message: 'Store address is required' }),
});

// User-scoped KYC docs (live on user_kyc_documents server-side). Partial
// submissions allowed; pair requirements are enforced in usePersonalKycService.
export const PersonalKycSchema = z.object({
  NIN_NUMBER: z.string().optional(),
  NIN_FILE: z.instanceof(File).optional(),
  BVN_NUMBER: z.string().optional(),
  UTILITY_BILL_FILE: z.instanceof(File).optional(),
  UTILITY_BILL_ADDRESS: z.string().optional(),
});

// All doc fields are optional at the schema level so partial submissions don't
// trip validation. Paired-field requirements (e.g. CAC_CERT must come with
// CAC_NUMBER) are enforced at submit time in useStoreServices.
export const StoreOfficialDocs = z.object({
  CAC_NUMBER: z.string().optional(),
  CAC_CERT: z.instanceof(File).optional(),
  TAX_IDENTIFICATION_NUMBER: z.string().optional(),
  TIN_CERTIFICATE: z.instanceof(File).optional(),
  ADDRESS: z.string().optional(),
  PROOF_OF_ADDRESS: z.instanceof(File).optional(),
  CAC_STATUS_REPORT: z.instanceof(File).optional(),
  MEMORANDUM_AND_ARTICLES: z.instanceof(File).optional(),
});

export const NewStoreSchema = z
  .object({
    ...StoreBrandFiles.shape,
    ...StorePrimaryInfo.shape,
    ...StoreOfficialDocs.shape,
  })
  .superRefine((value, ctx) => {
    // --- LOGO CHECK ---
    const hasLogoFile = value.store_logo instanceof File;
    const hasLogoId = typeof value.logo === 'number';

    if (!hasLogoFile && !hasLogoId) {
      ctx.addIssue({
        path: ['store_logo'],
        code: z.ZodIssueCode.custom,
        message: 'Please upload your store logo',
      });
    }
  });
